import { useEffect, useState } from "react";
import useFirestore from "shared/hooks/useFirestore";

const useLocation = (now_folder:string, selected_report:string) => {
    const {readFirestoreOneDoc} = useFirestore();
    const [locationList, setLocationList] = useState<string[]>([]);
    
    useEffect(() => {
        setLocationList([]);
        getLocationList();
        // eslint-disable-next-line
    }, [now_folder, selected_report])


    const getLocationList = async() => {
        if(!now_folder){
            setLocationList([])
            return;
        }

        let folder_id_list = now_folder.split("/");
        folder_id_list = folder_id_list.filter(item => item !== "Report");

        if(!folder_id_list.length){
            return;
        }

        let path = "Report";
        const location_list = [];
        for(const id of folder_id_list){
            const target_name = await readFirestoreOneDoc(path, id).then(res => {
                if(res.exists()){
                    return res.data().name;
                }
                return "";
            })
            if(target_name){
                location_list.push(target_name);
                path = path + "/" + id + "/Report"
            }
        }
        if(selected_report){
            const report_name = await readFirestoreOneDoc(path, selected_report).then(res => {
                if(res.exists()){
                    return res.data().name;
                }
                return "";
            })
            if(report_name){
                location_list.push(report_name);
            }
        }
        setLocationList(location_list);
    }

    return {locationList};
}

export default useLocation;